import { LanguageCodeEnum, LocaleEnum } from '@systemeio/types';
import { getLanguageCodeByLocale } from '@systemeio/util';
import Cookies from 'js-cookie';
import { useCallback, useEffect, useState } from 'react';
import { changeLanguage } from 'shared/api/user-api';
import { addLanguageResource } from 'shared/components/language-switcher/utils/add-language-resource';
import { LocalizeValues, useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { getRegisteredNamespaces } from 'shared/utils/i18n-resources';
import { LOCALE_COOKIE } from '../constants';
export const useLanguageSwitcher = () => {
  const {
    i18n
  } = useLocoTranslation();
  const {
    dashboardUser,
    mutate: mutateUser
  } = useUser();
  const [isChangingLanguage, setIsChangingLanguage] = useState(false);
  const changeNextLanguage = useCallback(async (languageCode: LanguageCodeEnum) => {
    for await (const ns of getRegisteredNamespaces<LocalizeValues>(i18n.options.ns)) {
      if (i18n.hasResourceBundle(languageCode, ns)) continue;
      await addLanguageResource(languageCode, ns, i18n);
    }
    if (i18n.language !== languageCode) {
      i18n.changeLanguage(languageCode);
    }
    const currentLocaleCookie = Cookies.get(LOCALE_COOKIE);
    if (currentLocaleCookie !== languageCode) {
      Cookies.set(LOCALE_COOKIE, languageCode);
    }
  }, [i18n]);
  useEffect(() => {
    const loadTranslations = async () => {
      if (!dashboardUser) return;
      const locale = dashboardUser?.dashboardLocale || LocaleEnum.ENGLISH;
      await changeNextLanguage(getLanguageCodeByLocale(locale));
    };
    loadTranslations();
  }, [changeNextLanguage, dashboardUser]);
  const handleChangeLanguage = async (locale_0: LocaleEnum) => {
    try {
      setIsChangingLanguage(true);
      if (dashboardUser) {
        await changeLanguage(locale_0);
      }
      await mutateUser(() =>
      // due to fallback data in useSWR, we need to use data directly, not from mutate
      dashboardUser && {
        ...dashboardUser,
        dashboardLocale: locale_0
      }, false);
    } catch (e) {
      console.log(e);
    } finally {
      setIsChangingLanguage(false);
    }
  };
  return {
    handleChangeLanguage,
    isChangingLanguage
  };
};